module.exports = __webpack_public_path__ + "img/cover-redeem-bg-mobile.41f41553.jpg";